import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-price-element-item',
  templateUrl: './price-element-item.component.html',
  styleUrls: ['./price-element-item.component.scss']
})
export class PriceElementItemComponent implements OnInit {

  @Input() priceElement;
  @Input() billingCompany;

  constructor() {
  }

  ngOnInit() {
  }

}
